import { object, string, number, array, date } from '@gogame/schemas';

import {
  RECURRENCE,
  REST_DAY_AFTER_ACTION,
  REST_DAY_CROSS_RULE,
  EVERY,
  AT_TIME,
  DAYS,
  ON_DATE,
  DAY,
  WEEK,
} from './constants';

export const scheduleSchema = object({
  [RECURRENCE]: string().default(DAY),
  [REST_DAY_AFTER_ACTION]: number()
    .min(0, 'hours must be >= 0')
    .max(30, 'hours must  <= 30'),
  [REST_DAY_CROSS_RULE]: number()
    .min(0, 'hours must be >= 0')
    .max(30, 'hours must  <= 30'),
  [EVERY]: number()
    .min(1, 'hours must be >= 1')
    .max(23, 'hours must be <= 23')
    .integer('hours must be an integer'),
  [AT_TIME]: string(),
  [DAYS]: array()
    .of(object())
    .when(RECURRENCE, {
      is: (val) => {
        return val === WEEK;
      },
      then: array()
        .of(object())
        .compact((v) => {
          const o = v && v[Object.keys(v)[0]];
          return !o;
        })
        .required('Please choose week days'),
    }),
  [ON_DATE]: date(),
});
